import { IppicaHeadersQuotaFissa } from 'types/swagger';
import { Size } from 'features/ippica/types';
import styles from './IppicaScommesseTableTitles.module.scss';

export interface TitleType extends IppicaHeadersQuotaFissa {
  size?: Size;
}

export type IppicaScommesseTableTitlesProps = {
  titles?: Array<TitleType>;
  containerClassName?: string;
};

export const IppicaScommesseTableTitles = ({ titles, containerClassName }: IppicaScommesseTableTitlesProps) => {
  return (
    <div className={`${styles.container} ${containerClassName ? containerClassName : ''}`}>
      {titles?.map((title, index) => {
        return (
          <span
            key={`${title}_ ${index}`}
            className={`${styles.title} ${title.size ? styles[title.size.toLowerCase()] : ''}`}
          >
            {title.label}
          </span>
        );
      })}
    </div>
  );
};
